export default "skymp5-front/76cbeb799fc98908a589dfcf1b0df4c6.svg";